import React, { useState, useEffect, useContext } from 'react';
import { API } from '../../../../API/API';
import FieldText from '../../../../components/FieldText/FieldText';
import FieldDropdown from '../../../../components/FieldDropdown/FieldDropdown';
import ButtonDefault from '../../../../components/ButtonDefault/ButtonDefault';
import { MessageConst } from '../../../../const/MessageConst';
import { message } from 'antd';
import { UserContext } from '../../../../context/UserContext';
import FieldDropdownMulti from '../../../../components/FieldDropdownMulti/FieldDropdownMulti';
import ButtonSecondary from '../../../../components/ButtonSecondary/ButtonSecondary';
import { constData } from '../../../../const/Const';
import PanelBase from '../../../../components/PanelBase/PanelBase';
import { checkEmail } from '../../../../SharedFunc/Email';

const UserNew = (props) => {

    const { userInfo } = useContext(UserContext);
    const [initData, setInitData] = useState({
        "userid": null,
        "password": null,
        "empid": props.empid,
        "companyid": userInfo.companyid,
        "companyname": userInfo.companyname,
        "email": null,
        "roleid": null,
        "status": "A",
        "licenseid": null,
        "datafilter": null,
        "depids": [],
        "ispasswordchanged": false,
        "fullname": null,
        "tstamp": null
    });
    const [data, setData] = useState({ ...initData });
    const [checkRule, setCheckRule] = useState(false);
    const [depData, setDepData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [dType, setDType] = useState(constData.User_Status);
    const [loading, setLoading] = useState(false);

    const [emailMessage, setEmailMessage] = useState();

    useEffect(() => {
        getData();
    }, [props.userid]);

    useEffect(() => {
        getInitData();
    }, []);

    const getData = async () => {
        let tData = { ...initData };
        if (props.userid) {
            setLoading(true);
            await API.get('/api/shared/user-management/user?userid=' + props.userid).then(response => {
                if (response.status === 200 && response.data.rettype === 0) {
                    if (response.data?.retdata) {
                        tData = response.data?.retdata;
                    }
                }
            });
            setLoading(false);
        }
        setData(tData);
    }

    const getInitData = async () => {
        let tDepData = [];
        let tRolData = [];

        setLoading(true);
        await API.get('/api/humanresource/organization/get_department_dropdown?companyid=' + userInfo.companyid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data?.retdata) {
                    tDepData = response.data?.retdata;
                }
            }
        });
        await API.get('/api/shared/user-management/role/DropDown').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data?.retdata) {
                    tRolData = response.data?.retdata;
                }
            }
        });
        setLoading(false);

        setDepData(tDepData);
        setRoleData(tRolData);
    }

    const fieldOnChanged = async (key, text, field) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (field === 'password') {
                tData['ispasswordchanged'] = true;
            }
            setData(tData);
        }
    }

    const onSave = async (p_close) => {

        setCheckRule(true);
        setEmailMessage();

        let tData = { ...data };

        let isValid = true;
        if (!tData.userid
            || !tData.password
            || !tData.email
            || !tData.roleid) {
            isValid = false;
        }

        if (tData?.email) {
            if (!checkEmail(tData?.email)) {
                setEmailMessage("Имэйл буруу байна");
                isValid = false;
            }
        }

        if (isValid) {

            tData.empid = props.empid;
            await API.post('/api/shared/user-management/user', tData, {
                ignoreRetType: true
            }).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    clearData();
                    if (props.afterSave) {
                        props.afterSave(p_close);
                    }
                } else if (response.data.rettype != 0 && response.data.retmsg.startsWith('ORA-00001')) {
                    message.error(tData?.userid + " уг нэвтрэх нэрийг ашиглах боломжгүй байгаа тул өөр нэр сонгоно уу.");
                } else {
                    message.error(response?.data?.retmsg);
                }
            });
        }
    }

    const onDelete = async () => {
        if (props.userid) {
            setLoading(true);
            await API.delete('/api/shared/user-management/user?userID=' + props.userid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    clearData();
                    if (props.afterSave) {
                        props.afterSave(true);
                    }
                }
            });
            setLoading(false);
        }
    }

    const clearData = () => {
        setData({ ...initData });
        setCheckRule(false);
    }

    return (
        <PanelBase
            headerText={props.userid ? 'Хэрэглэгч засах' : 'Хэрэглэгч нэмэх'}
            isOpen={props.isOpen}
            onDismiss={props.onDismiss}
            isFooterAtBottom={true}
            onDelete={onDelete}
            delete={props.userid}
            buttons={
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div>
                        <ButtonSecondary onClick={() => onSave(false)} text="Хадгалаад шинэ" />
                    </div>
                    <div style={{ marginLeft: 16 }}>
                        <ButtonDefault text="Хадгалах" onClick={() => { onSave(true) }} />
                    </div>
                </div>
            }
        >
            <div style={{ marginTop: 29 }}>
                <FieldText autoComplete='off' required onChanged={fieldOnChanged} disable={props.userid ? true : false} title="Нэвтрэх нэр" keyfield='userid' defaultValue={data.userid} checkreq={checkRule} />
            </div>
            <div style={{ marginTop: 13 }}>
                <FieldText autoComplete='new-password' required type="password" onChanged={fieldOnChanged} title="Нууц үг" keyfield='password' defaultValue={data.password} checkreq={checkRule} />
            </div>
            <div style={{ marginTop: 13 }}>
                <FieldText onChanged={fieldOnChanged} disable={true} title="Албан байгууллага" keyfield='companyname' defaultValue={data.companyname} />
            </div>
            <div style={{ marginTop: 13 }}>
                <FieldText autoComplete='off' required onChanged={fieldOnChanged} title="И-мэйл" keyfield='email' defaultValue={data.email} checkreq={checkRule} message={emailMessage} />
            </div>
            <div style={{ marginTop: 13 }}>
                <FieldDropdown required onChanged={fieldOnChanged} title="Үүрэг" loading={loading} data={roleData} keyfield='roleid' defaultValue={data.roleid} checkreq={checkRule} />
            </div>
            <div style={{ marginTop: 13 }}>
                <FieldDropdownMulti onChanged={fieldOnChanged} title="Мэдээлэл" loading={loading} data={depData} keyfield='depids' defaultValue={data.depids} />
            </div>
            <div style={{ marginTop: 13 }}>
                <FieldDropdown onChanged={fieldOnChanged} title="Төлөв" data={dType} loading={loading} keyfield='status' defaultValue={data.status} />
            </div>
        </PanelBase>
    );
}

export default UserNew;